import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


import '../../styles/chapter2/user_questions.scss';

import Iconset from '../icons';

class User_questions extends React.Component{

	constructor(props){
		super(props);
		this.state = {
			evaluate : "none",
			isChecked : false
		}
		this.form = null;
		this.inputs = [];
		//console.log(this.props);
	}

	isChecked(){
		this.setState({
			isChecked : true
		})
	}

	showAnswer(event){
		event.preventDefault();

		this.button.setAttribute('disabled',true);

		this.props.data.userQuestion[this.props.selectedUserQuestion].answer.forEach(function(answer,index){
			this.inputs[index].setAttribute('disabled',true);
			
			if(answer.correct){
				this.inputs[index].classList.add('answered-correct');
				this.setState({
					evaluate : answer.correct && this.inputs[index].checked,
				},function(){
					this.props.addUserAnswer(this.state.evaluate);

					console.log(this.state.evaluate);
				});
			}else{
				this.inputs[index].classList.add('answered-incorrect');
			}
		}.bind(this));
	}

	render(){
		return (
			<div className="user-question-stack">
				<div className="user-question-stack-inner">
					<h2>{this.props.data.userQuestion[this.props.selectedUserQuestion].frage}</h2>
					<form className={"answered-" + this.state.evaluate + " isChecked-" + this.state.isChecked} name="user-question" ref={(form)=>{this.form = form}} onSubmit={(event)=>this.showAnswer(event)}>
						{this.props.data.userQuestion[this.props.selectedUserQuestion].answer.map(function(answer,index){
							return (<div className="user-question-answer">
								<input onChange={()=>this.isChecked()} type="radio" id={"user-question-" + index} ref={(inputField)=>{this.inputs[index] = inputField;}} value="" name="user-question" className="question-user-button" />
								<label htmlFor={"user-question-" + index}>
									<div className="ico wrong">
										<Iconset.crossIcon />
									</div><div className="ico correct">
										<Iconset.correctArrowIcon />
									</div>{answer.text}</label>
							</div>);
						}.bind(this))}
						<ReactCSSTransitionGroup
						component= "div"
						className={"user-question-answer-evaluation"}
						transitionName="fade"
						transitionAppear={true}
						transitionAppearTimeout={500}
						transitionEnterTimeout={500}
						transitionLeaveTimeout={300}>
							{this.state.evaluate != "none" && this.state.evaluate &&
								<p className="user-question-answer-evaluation-content">You're right!</p>
							}{this.state.evaluate != "none" && !this.state.evaluate &&
								<p className="user-question-answer-evaluation-content">You're wrong!</p>
							}
						</ReactCSSTransitionGroup>
						<button ref={(button)=>{this.button=button;}} className="user-question-button">Check and continue</button>
						
					</form>
				</div>
			</div>);
	}
}


export default User_questions;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/user_questions.js